import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import ProductCard from '../components/ProductCard'

const FromCategory = ({ categoryName, currentSlug }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulProduit {
        nodes {
          category {
            name
          }
          price
          pricePromo
          slug
          title
          image {
            fluid(maxHeight: 350, maxWidth: 450) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          id
        }
      }
    }
  `)
  return (
    <div className="highlights--container">
      {data.allContentfulProduit.nodes
        .filter(
          product =>
            product.category.name === categoryName &&
            product.slug !== currentSlug
        )
        .map(product => {
          return <ProductCard key={product.slug} product={product} />
        })}
    </div>
  )
}

export default FromCategory
